exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* TEXTFIELD */\n\n/* LIST */\n\n/* ==========  Layout  ========== */\n\n/* BUTTON */\n\n/* ANIMATION */\n\n/* Small control size */\n\n.wrapper {\n  flex-direction: column;\n  flex-grow: 1;\n  display: flex;\n}\n\n.wrapper .toolbar {\n  display: flex;\n  justify-content: flex-end;\n}\n\ncovance-ag-grid ::ng-deep .ag-header {\n  height: 54px !important;\n  min-height: 54px !important;\n}\n\ncovance-ag-grid ::ng-deep .ag-theme-material .ag-floating-filter-button {\n  margin-top: 0px;\n}\n\ncovance-ag-grid ::ng-deep .ag-theme-material .ag-filter .ag-set-filter-list {\n  height: fit-content;\n}\n\n", ""]);

// exports
